import dynamic from "next/dynamic";
const CardsGridComponent = dynamic(()=>import("./cards-grid-component"));
import CardsGridConfig from "./cards-grid-config";
import CardsGridAdvancedConfig from "./cards-grid-advanced-config";
export default {
    CardsGridComponent,
    CardsGridConfig,
    CardsGridAdvancedConfig
};
